export default "__VITE_ASSET__f9086d1d__"